
export default {
    Menu: require('mk-component/lib/components/menu'),
    Icon: require('mk-component/lib/components/icon'),
    Card: require('mk-component/lib/components/card'),
    Collapse: require('mk-component/lib/components/collapse'),
    Layout: require('mk-component/lib/components/layout'),
    Button: require('mk-component/lib/components/button'),
    DatePicker: require('mk-component/lib/components/datePicker'),
    Checkbox: require('mk-component/lib/components/checkbox'),
    Radio: require('mk-component/lib/components/radio'),
    Switch: require('mk-component/lib/components/switch'),
    Link: require('mk-component/lib/components/link'),
    Tabs: require('mk-component/lib/components/tabs'),
    Tree: require('mk-component/lib/components/tree'),
    TreeSelect: require('mk-component/lib/components/treeSelect'),
    Affix: require('mk-component/lib/components/affix'),
    Anchor: require('mk-component/lib/components/anchor'),
    BackTop: require('mk-component/lib/components/backTop'),
    Badge: require('mk-component/lib/components/badge'),
    Breadcrumb: require('mk-component/lib/components/breadcrumb'),
    Carousel: require('mk-component/lib/components/carousel'),
    Cascader: require('mk-component/lib/components/cascader'),
    Message: require('mk-component/lib/components/message'),
    Toast: require('mk-component/lib/components/toast'),
    Modal: require('mk-component/lib/components/modal'),
    Alert: require('mk-component/lib/components/alert'),
    Notification: require('mk-component/lib/components/notification'),
    Popconfirm: require('mk-component/lib/components/popconfirm'),
    Popover: require('mk-component/lib/components/popover'),
    Tooltip: require('mk-component/lib/components/tooltip'),
    Spin: require('mk-component/lib/components/spin'),
    Progress: require('mk-component/lib/components/progress'),
    Timeline: require('mk-component/lib/components/timeline'),
    Pagination: require('mk-component/lib/components/pagination'),
    Steps: require('mk-component/lib/components/steps'),
    Rate: require('mk-component/lib/components/rate'),
    Slider: require('mk-component/lib/components/slider'),
    Upload: require('mk-component/lib/components/upload'),
    Transfer: require('mk-component/lib/components/transfer'),
    Input: require('mk-component/lib/components/input'),
    Select: require('mk-component/lib/components/select'),
    Dropdown: require('mk-component/lib/components/dropdown'),
    //Echarts: require('mk-component/lib/components/echarts'),
    DataGrid: require('mk-component/lib/components/datagrid'),
    Table: require('mk-component/lib/components/table'),
    Form: require('mk-component/lib/components/form'),
    GridLayout: require('mk-component/lib/components/gridLayout'),
    //JSONTree: require('mk-component/lib/components/jsonTree'),
    //Attachment: require('mk-component/lib/components/attachment'),
    Movable: require('mk-component/lib/components/movable'),
    List: require('mk-component/lib/components/list'),
    Avatar: require('mk-component/lib/components/movable'),
    localeWrapper: require('mk-component/lib/components/localeWrapper'),
}
/*
export default {
    Menu: require('mk-component/lib/components/menu'),
    Icon: require('mk-component/lib/components/icon'),
    //Card: require('mk-component/lib/components/card'),
    //Collapse: require('mk-component/lib/components/collapse'),
    Layout: require('mk-component/lib/components/layout'),
    Button: require('mk-component/lib/components/button'),
    //DatePicker: require('mk-component/lib/components/datePicker'),
    //Checkbox: require('mk-component/lib/components/checkbox'),
    //Radio: require('mk-component/lib/components/radio'),
    //Switch: require('mk-component/lib/components/switch'),
    //Link: require('mk-component/lib/components/link'),
    //Tabs: require('mk-component/lib/components/tabs'),
    //Tree: require('mk-component/lib/components/tree'),
    //TreeSelect: require('mk-component/lib/components/treeSelect'),
    //Affix: require('mk-component/lib/components/affix'),
    Anchor: require('mk-component/lib/components/anchor'),
    //BackTop: require('mk-component/lib/components/backTop'),
    //Badge: require('mk-component/lib/components/badge'),
    //Breadcrumb: require('mk-component/lib/components/breadcrumb'),
    //Carousel: require('mk-component/lib/components/carousel'),
    //Cascader: require('mk-component/lib/components/cascader'),
    //Message: require('mk-component/lib/components/message'),
    Toast: require('mk-component/lib/components/toast'),
    Modal: require('mk-component/lib/components/modal'),
    //Alert: require('mk-component/lib/components/alert'),
    Notification: require('mk-component/lib/components/notification'),
    //Popconfirm: require('mk-component/lib/components/popconfirm'),
    Popover: require('mk-component/lib/components/popover'),
    Tooltip: require('mk-component/lib/components/tooltip'),
    //Spin: require('mk-component/lib/components/spin'),
    //Progress: require('mk-component/lib/components/progress'),
    //Timeline: require('mk-component/lib/components/timeline'),
    //Pagination: require('mk-component/lib/components/pagination'),
    //Steps: require('mk-component/lib/components/steps'),
    //Rate: require('mk-component/lib/components/rate'),
    //Slider: require('mk-component/lib/components/slider'),
    //Upload: require('mk-component/lib/components/upload'),
    //Transfer: require('mk-component/lib/components/transfer'),
    Input: require('mk-component/lib/components/input'),
    //Select: require('mk-component/lib/components/select'),
    //Dropdown: require('mk-component/lib/components/dropdown'),
    Echarts: require('mk-component/lib/components/echarts'),
    DataGrid: require('mk-component/lib/components/datagrid'),
    Table: require('mk-component/lib/components/table'),
    Form: require('mk-component/lib/components/form'),
    //GridLayout: require('mk-component/lib/components/gridLayout'),
    //JSONTree: require('mk-component/lib/components/jsonTree'),
    //Attachment: require('mk-component/lib/components/attachment'),
    //Movable: require('mk-component/lib/components/movable'),
    localeWrapper: require('mk-component/lib/components/localeWrapper'),
}
*/